import { DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { WindowService, WindowServiceInjector } from '@next/core-lib/window';
import { select, Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { CropField, GroupedCropFields } from 'src/app/shared/models';

import { getCropYear, getReportSort } from 'src/app/store/selectors';

import { getGroupedCropFields } from '../../registration/store/selectors/crop-field.selectors';
import { ReportSortService } from '../services/report-sort.service';

export interface CropFieldData {
  groupedCropFields: GroupedCropFields;
  cropFields: CropField[];
}

@Component({
  selector: 'app-cropfield-overview',
  templateUrl: './cropfield-overview.component.html',
  styleUrls: ['./../reports.scss'],
  standalone: false,
})
export class CropFieldOverviewComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly locale = inject(LocaleService);
  private readonly sortService = inject(ReportSortService);
  protected decimalPipe = inject(DecimalPipe);
  private readonly window = inject<WindowService>(WindowServiceInjector);
  private readonly router = inject(Router);

  subscription = new Subscription();
  today = new Date();
  customer$ = this.store.pipe(select(UserSelectors.selectCustomer));
  reportSort$ = this.store.pipe(select(getReportSort));
  cropYear$ = this.store.pipe(select(getCropYear));
  groupedCropFields$ = this.store.pipe(select(getGroupedCropFields));

  buttonItems$ = this.sortService.getButtonItems();

  ngOnInit() {
    //this.title = this.locale.translate('overview');
    this.subscription.add(
      combineLatest([this.customer$, this.cropYear$]).subscribe(([customer, year]) => {
        const pageTitle = `${customer?.name ? customer.name : ''} ${this.locale.translate(
          'fieldOverview',
        )} ${year}`;
        this.store.dispatch(SiteActions.updatePageTitle({ pageTitle }));
      }),
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  print() {
    if (this.window) {
      this.window.print();
    }
  }

  back() {
    this.router.navigate(['/']);
  }

  buttonAction(data: string) {
    this.sortService.handleButtonAction(data);
  }
}
